export const SMALL_FILE_LINE_THRESHOLD = 50;

export const POLLING_CONFIG_SMALL = {
	MAX_ATTEMPTS: 3,
	INTERVAL_MS: 5000,
	TOAST_DURATION: 5000,
	ERROR_TOAST_DURATION: 8000,
	INITIAL_DELAY_MS: 5000,
	STABLE_VERIFICATIONS_REQUIRED: 1,
} as const;

export const POLLING_CONFIG_LARGE = {
	MAX_ATTEMPTS: 8,
	INTERVAL_MS: 30000,
	TOAST_DURATION: 5000,
	ERROR_TOAST_DURATION: 8000,
	INITIAL_DELAY_MS: 30000,
	STABLE_VERIFICATIONS_REQUIRED: 3,
} as const;

export const POLLING_CONFIG = POLLING_CONFIG_LARGE;

export type PollingConfig = {
	readonly MAX_ATTEMPTS: number;
	readonly INTERVAL_MS: number;
	readonly TOAST_DURATION: number;
	readonly ERROR_TOAST_DURATION: number;
	readonly INITIAL_DELAY_MS: number;
	readonly STABLE_VERIFICATIONS_REQUIRED: number;
};

export const getPollingConfig = (numberOfLines: number): PollingConfig => {
	return numberOfLines <= SMALL_FILE_LINE_THRESHOLD
		? POLLING_CONFIG_SMALL
		: POLLING_CONFIG_LARGE;
};

export const TOAST_MESSAGES = {
	SUCCESS: {
		title: 'Alterações aplicadas!',
		description: 'As alterações foram processadas e aplicadas com sucesso.',
	},
	PROCESSING_COMPLETE: {
		title: 'Processamento concluído',
		description:
			'O processamento em etapas foi finalizado. A tabela foi atualizada automaticamente.',
	},
	UPLOAD_ERROR: {
		title: 'Arquivo enviado com erros!',
		description:
			'O Arquivo enviado possui erros. Verifique a tabela de erros e corrija-os.',
	},
	UNKNOWN_ERROR: {
		title: 'Erro desconhecido!',
		description: 'Tente enviar novamente.',
	},
} as const;

export const QUERY_KEYS = {
	PRODUTO_LIST: ['produto-list'] as const,
} as const;
